import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CompanyOffersService } from "app/company-offers/services/company-offers.service";
import { ICompanySpecificInfo } from "app/company-offers/services/icompany-specific-info";
import * as emiGlobals from 'app/globals';
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import $ from 'jquery/dist/jquery';

@Component({
  selector: 'cs-home-loan-form',
  templateUrl: './cs-home-loan-form.component.html',
  styleUrls: ['./cs-home-loan-form.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CsHomeLoanFormComponent implements OnInit {
   defaultQuoteLoanAmount = "1,00,000";
  @Input() type;
  @Input() pageData;
  @Input() otheroffer;

  dataLoading=false;

  loanApplyForm : FormGroup;
  companyInfo:ICompanySpecificInfo;

  default=true;
  x=true;
  hide_personalize=true;
  more_personalize_mobile=false;

  is_co_applicant_enabled:boolean=false;
  title="Personalise my offers.";
  hide_on_mobile:boolean=true;
  hide_on_desktop:boolean=true;
  more_personalize = false;
  typeOfReducePl;

  options_locations=this.loanOfferService.getCityList();
  options_bank=this.loanOfferService.getBankList();
  // options_bank = emiGlobals.SalaryBankEnum;
  options_gender = emiGlobals.GenderEnum;
  option_loan_tenure = emiGlobals.HLLoanTenureEnum;
  option_workexp = emiGlobals.WorkExperienceEnum;
  option_co_employment_type = emiGlobals.HLEmploymentTypeEnum;


  CoAppEmpType="Salaried";
  CoAppEmp = {
      income_title: "Net Monthly Salary",
      bank_title: "Salary Account Bank"
  };
  current_appicant="Applicant";
  loan_amount_label = "Loan Amount";

  dataToApi;
  loan_amount_generated:boolean=false;

  constructor(
    private fb: FormBuilder,
    private companyOffersService:CompanyOffersService,
    private loanOfferService:LoanOfferGenService,
    route: ActivatedRoute
  ) { 
    
    
    this.typeOfReducePl=route.snapshot.data['type'];
  }
   

  ngOnInit() {
    console.log(this.pageData);
    this.loanOfferService.checkHasLocalData();
    this.buildForm();
    if(this.typeOfReducePl == 'home-loan-transfer'){
      this.loan_amount_label = "Loan Outstanding";
    }
    let formdata=JSON.stringify(this.loanApplyForm.getRawValue());
    let sendingData=JSON.parse(formdata);
    this.submitForm(sendingData);
  }

  ngOnChanges(changes: SimpleChanges) {

    if(changes['pageData']) {
      this.buildForm();
      this.buildText();
      this.loanOfferService.updateCustomerInfoData({
              "loan_type":this.type,
            });
      if(this.type == emiGlobals.HomeLoan_Transfer){
        this.loan_amount_label = "Loan Outstanding";
      }
    }

  }
  
  buildForm(){

        this.loanApplyForm = this.fb.group({
        
        'netsal': [this.getFielsDefaultValue('netsalary',this.pageData.pl_netsalary), Validators.compose([Validators.required, Validators.minLength(3)])],
        'ex_emi':[this.getFielsDefaultValue('existing_emi',this.pageData.pl_emi), Validators.compose([Validators.required])],
        'bank':[this.getFielsDefaultValue('salary_bank_account_id',this.pageData.salarybank), Validators.compose([Validators.required])],
        'workexp':[this.pageData.workexp_id, Validators.compose([Validators.required])],
        'age':[this.getFielsDefaultValue('age',this.pageData.pl_age), Validators.compose([Validators.required])],
        'city':[this.getFielsDefaultValue('location_id',this.pageData.location), Validators.compose([Validators.required])],
        'gender':[this.getFielsDefaultValue('gender_id',this.pageData.gender), Validators.compose([Validators.required])],
        'bonus':[0],

        'sal':[1, Validators.compose([Validators.required])],
        'company':[],
        'purp':[this.getTypeSpecificValue('purp'), Validators.compose([Validators.required])],
        'loanamt':[this.pageData.hl_loan_amount, Validators.compose([Validators.required])],
        'tenure':[this.pageData.hl_tenure, Validators.compose([Validators.required])],
        'propval' :[this.getFielsDefaultValue('propval',this.pageData.property_value?this.pageData.property_value:5000000),Validators.compose([Validators.required])],

        'cosal'   :this.getFielsDefaultValue('cosal',0),
        'cobank'  :[this.getFielsDefaultValue('cobank_id',0)],
        'cogender':[this.getFielsDefaultValue('cogender_id','0')],
        'cocompany':null,
        'coworkexp':[this.getFielsDefaultValue('coworkexp_id',2)],
        'depre'   :this.getFielsDefaultValue('depre',0),
        'conetsal':[this.getFielsDefaultValue('conetsalary','25000')],
        'codepre' :this.getFielsDefaultValue('codepre',0),
        'coex_emi':[this.getFielsDefaultValue('coex_emi','0')],
        'conature':this.getFielsDefaultValue('conature'),
        'cobonus':[this.getFielsDefaultValue('cobonus','0')],

      });
  }

  buildText(){
    if(this.type == emiGlobals.HomeLoan_New){
      this.title = "Personalise my offers.";
    }else{
      this.title = "Personalise my offers."; 
    }
  }

  showForm(){
    this.hide_on_mobile=false;
  }

  getFielsDefaultValue(field,defaultvalue=null){
    var data = this.loanOfferService.getLocalCustomerInfoData(field);
    return (data?data:defaultvalue);
  }

  onCoAppEmploymentChange(co_app_emp_value){
    //console.log("onCoAppEmploymentChange",co_app_emp_value);
    if(co_app_emp_value==0||co_app_emp_value==1){
      this.CoAppEmpType="Salaried";
      this.CoAppEmp.income_title = "Net Monthly Salary";
      this.CoAppEmp.bank_title = "Salary Account Bank";
    }else if(co_app_emp_value==2){
      this.CoAppEmpType="Doctor";
      this.CoAppEmp.income_title = "Net Profit Per Annum";
      this.CoAppEmp.bank_title = "Savings Account Bank";
    }else{
      this.CoAppEmpType="Other";
      this.CoAppEmp.income_title = "Net Profit Per Annum";
      this.CoAppEmp.bank_title = "Current Account Bank";
    }
  }

  getTypeSpecificValue(field):number{
    switch(this.type){
      case emiGlobals.HomeLoan_New:
        switch(field){
          case 'purp': {  return 1; }
          case 'pid' : {  return 1; }
        }
      break;
      case emiGlobals.HomeLoan_Transfer:
        switch(field){
          case 'purp': {  return 6; }
          case 'pid' : {  return 1; }
        }
      break;
    }
  }

  submitForm(values){
    debugger
      this.dataLoading=true;
      console.log(values);
      console.log(this.loanApplyForm.value);
      
      try {

        let values_workexp =  (values.workexp?values.workexp:0);
        let dataToApi           = Object.assign({}, values);

        this.loanOfferService.updateCustomerInfoData(
            {
              "loan_amount":values.loanamt,
              "loan_tenure":this.option_loan_tenure[values.tenure].name,
              "netsalary":values.netsal,
              "existing_emi":values.ex_emi,
              "salary_bank_account":this.options_bank[values.bank].name,
              "salary_bank_account_id":values.bank,
              "work_exp":this.option_workexp[values_workexp].name,
              "work_exp_id":values.workexp,
              "gender":this.options_gender[values.gender].name,
              "gender_id":values.gender,
              "location":this.options_locations[values.city].name,
              "location_id":values.city,
              "loan_type":this.type,
              "conetsalary":values.conetsal,
              "coex_emi":values.coex_emi,
              "cogender_id":values.cogender,
              "coworkexp_id":values.coworkexp,
              "cobonus":values.cobonus,
              "cobank":this.options_bank[values.cobank].name,
              "cobank_id":values.cobank,
            }
        );
        

        
        dataToApi.bank          = this.options_bank[values.bank].value;
        dataToApi.tenure        = this.option_loan_tenure[values.tenure].value;
        dataToApi.workexp       = this.option_workexp[values_workexp].value;
        dataToApi.city          = this.options_locations[values.city].value;
        dataToApi.gender        = this.options_gender[values.gender].value;
        dataToApi.loan_type     = this.type;

        if(this.is_co_applicant_enabled){
          this.loanOfferService.updateCustomerInfoData(
              {
                "co_employmet_type":this.option_co_employment_type[values.cosal].name,
                "co_salary_bank":this.options_bank[values.cobank].name,
                "co_income":values.conetsal,
                "co_gender":this.options_gender[values.cogender].name,
                "co_prof_nature":values.conature,
                "co_emi":values.coex_emi,
                "co_work_exp":this.option_workexp[values.coworkexp].name
              }
          );

          dataToApi.coworkexp     = this.option_workexp[values.coworkexp].value;
          dataToApi.cogender      = this.options_gender[values.cogender].value;
          dataToApi.cobank        = this.options_bank[values.cobank].value;
          dataToApi.cosal        = this.option_co_employment_type[values.cosal].value;

        }else{
          delete dataToApi.coworkexp;
          delete dataToApi.cogender;
          delete dataToApi.cobank;
          delete dataToApi.cocompany;
          delete dataToApi.codepre;
          delete dataToApi.coex_emi;
          delete dataToApi.conature;
          delete dataToApi.conetsal;
          delete dataToApi.cosal;
          delete dataToApi.cobonus;
          
        }

        this.loan_amount_generated=true;
        this.dataToApi = dataToApi;

        dataToApi.pid           = this.getPid('form');
        console.log(dataToApi);
        debugger
        this.loanOfferService.generateHLOffer(dataToApi);
        return null;
        
      } catch (error) {
        console.log(error);
      }
  }

  updateAddCoApplicant(status){
    this.default=false;
    this.is_co_applicant_enabled = status;
    if(this.current_appicant=="Applicant"){
      this.current_appicant="Co Applicant";
    }else{
      this.current_appicant="Applicant";
    }
  }
  RemoveCoApplicant(value){
    this.default=true;
    this.is_co_applicant_enabled=value;
    this.current_appicant="Applicant"
 }
  

  // Show Age, Gender and Work exp form : Show / Hide
  updatePersonalize(value){
    this.more_personalize = !this.more_personalize;
  }
  updatePersonalizeMobile(value){
      this.x=false;
      this.hide_personalize=false;
      this.more_personalize_mobile=value;
    // this.carouselindicators.next();
  }

  eligibiliityCheck(type:string,amount:number){

    this.dataToApi.loanamt  = amount;
    this.dataToApi.pid      = this.getPid(type);
    this.loanOfferService.generateHLOffer(this.dataToApi);
    // this.loanOfferService.generateOffer(this.dataToApi);
  }

  getPid(tag:string){
    let purp  = this.type;
    let pid = 1;

    //Salaried New loan
         if(tag=="form" && purp == emiGlobals.HomeLoan_New){ pid = 1; }
    else if(tag=="income" && purp == emiGlobals.HomeLoan_New){ pid = 2; }
    else if(tag=="property" && purp == emiGlobals.HomeLoan_New){ pid = 3; }
    // Balance Transfer
    else if(tag=="form" && purp == emiGlobals.HomeLoan_Transfer){ pid = 1; } 
    else if(tag=="income" && purp == emiGlobals.HomeLoan_Transfer ){ pid = 2; } 
    else if(tag=="property" && purp == emiGlobals.HomeLoan_Transfer ){ pid = 3; } 
    
    return pid;
  }

  fetchHLCompany(event){
    this.loanOfferService.searchHomeBankComanyName(event.query)
      .subscribe(response => event.result(response));
  }

   toggleApplicant(){
    if(this.is_co_applicant_enabled){
      if(this.current_appicant=="Applicant"){
        this.current_appicant="Co Applicant";
      }else{
        this.current_appicant="Applicant";
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/company-offers/cs-home-loan-form/cs-home-loan-form.component.ts